$(document).ready(function()
{
	/*
	//
	// 
	// MENUS
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('#mobile-menu').mmenu(
	{
		// OPTIONS
		navbar:
		{
			add: true,
			title: "<svg viewBox='0 0 306 30.3' style=''><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#local-eclectic-logo'></use></svg>",
			titleLink: 'parent'
		},
      	searchfield:
      	{
        add: true,
        search: false
    	},
		//extensions: ["pagedim-black"],
		offCanvas:
		{
			position: 'right'
		}
	},
	{
		// CONFIGURATION
		offCanvas:
		{
			pageSelector: '#wrapper',
		},
		classNames:
		{
			selected: "active"
		}
	});


	
  
  	//
	//
	// TRIGGER SEARCH ON MMENU 
	// http://stackoverflow.com/questions/18870994/use-searchfield-in-mmenu-for-normal-search
	//
  	$("#mobile-menu .mm-search input").keyup(function(e){
    if(e.keyCode == 13){
        window.location.href = '/search?type=&q=' + $(this).val();
    }
	});
	
	//
	//
	// CLOSE MOBILE MENU ON WINDOW RESIZE TO DESKTOP
	//
	//
	var MM_mobile = $('#mobile-menu').data('mmenu');
	var MM_desktop = $('#desktop-menu').data('mmenu');
	
	$(window).resize(function()
	{
		if ($('#header-desktop').is(':visible'))
		{
			MM_mobile.close();
		}
	});
	
	
	/*
	//
	// 
	// MOBILE ARTICLE INNER MENUS
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('.also-in h4').on('click', function(e) {
      $('.also-in').toggleClass("open"); //you can list several class names 
      e.preventDefault();
    });
	
	/*
	//
	// 
	// DESKTOP MENU FLYOUTS
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('#desktop-menu .has-flyout').mouseenter(function(e)
	{
		var menu = $(this).find('a').data('menu');
		$(menu).show();
		
	}).mouseleave(function(e)
	{
		var to = e.toElement || e.relatedTarget;
		var parent_is_flyout = $(to).parents('.menu-flyout');
		
		if (!$(to).hasClass('menu-flyout') && parent_is_flyout.length < 1)
		{
			var menu = $(this).find('a').data('menu');
			$(menu).hide();	
		}
	});
	
	$('.menu-flyout').mouseleave(function(e)
	{
		$(this).hide();
	});
	
	
	
	
	$('#menu-shop-slider').owlCarousel(
	{
		loop:true,
		items:2,
		pagination:true,
		center:false,
		nav:true,
		lazyLoad:true,
		navContainer:$('#menu-shop-callout .carousel-nav'),
		navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"]
	});
	
	
	
	$('#menu-designers a').hover(function()
	{
		var designer = $(this).attr('data-designer');
		
		if ($('.menu-designers-block[data-designer=' + designer + ']').length > 0)
		{
			$('.menu-designers-block').not('[data-designer=' + designer + ']').fadeOut(90);
			$('.menu-designers-block[data-designer=' + designer + ']').fadeIn(90);
		}
	});
	
	
	
	/*
	//
	//
	// BANNERS SLIDERS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.banners-slider').each(function()
	{
		var $pagination_container = $(this).parents('.banners-slider-container').find('.carousel-pagination');
		var $navigation_container = $(this).parents('.banners-slider-container').find('.carousel-nav');
		
		$(this).owlCarousel(
		{
			loop:true,
			items: 1,
			center:true,
			pagination:true,
			dotsContainer:$pagination_container,
			nav:true,
			navContainer:$navigation_container,
			navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
			lazyLoad:true
		});	
		
	});
	
	/*
	//
	//
	// DESIGNERS SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	var designers_links_slider_clicked = false;
	
	var $designers_slider = $('#designers-slider .owl-carousel').owlCarousel(
	{
		loop:true,
		items: 1,
		pagination:false,
		center:true,
		nav:true,
		lazyLoad:true,
		navContainer:$('#designers-slider .carousel-nav'),
		navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"]
	});
	
	$designers_slider.on('changed.owl.carousel', function(e)
	{
		var slide_index = e.page.index;
		
		$('#designers-links-slider a').removeClass('active');
		$($('#designers-links-slider a')[slide_index]).addClass('active');
		
		if (!designers_links_slider_clicked)
		{
			$('#designers-links-slider').trigger('to.owl.carousel', slide_index);
		}
		
		designers_links_slider_clicked = false;
	});
	
	$('#designers-links-slider a').click(function(e)
	{
		e.preventDefault();
		
		designers_links_slider_clicked = true;
			
		$(this).siblings().removeClass('active');
		$(this).addClass('active');
		
		if ($(this).parents('.owl-item').length > 0)
		{
			var slide_index = $(this).parents('.owl-item').index();	
		}
		else
		{
			var slide_index = $(this).index();
		}
		
		$('#designers-slider .owl-carousel').trigger('to.owl.carousel', slide_index)
		
		return false;	
	});
	
	
	
	
	/*
	//
	//
	// LINKS SLIDERS
	// => PART OF DESIGNERS SLIDER (SEE INDEX)
	// => AND STANDALONE (SEE BLOG HOME)
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	toggleLinksSliders();
	
	$(window).resize(function()
	{
		toggleLinksSliders();	
	});
	
	function toggleLinksSliders()
	{
		if ($(window).width() >= 500)
		{
			$('.links-slider').trigger('destroy.owl.carousel');	
		}
		else
		{
			$('.links-slider').owlCarousel(
			{
				loop:false,
				items: 3,
				pagination:false,
				center:false,
				nav:false,
				autoWidth:true
			});
		}
	}
	
	/*
	//
	//
	// FAQ ACCORDIONS
	//
	//
	//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */
	
	/*
	//
	//
	// BUILD HTML STRUCTURE FOR ACCORDION FROM WYSIWYG EDITOR
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('.faq-accordion li.top').each(function(i,v)
	{
		if ($(this).find('.accordion-header').length < 1)
		{
			var h3 = $(this).find('h3').html();
			$(this).find('h3').remove();
			
			var content = $(this).html();
			
			var new_content = $("<div></div>");
			new_content.append("<h3 class='accordion-header'>&plus; " + h3 + "</h3>");
			new_content.append("<div class='accordion-content'>" + content + "</div>");
			
			$(this).html($(new_content).html());
		}
		
		$(this).show();
		
	});
	
	/*
	//
	//
	// FAQ ACCORDION COLLAPSE
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('.faq-accordion .accordion-header').click(function(e)
	{
		e.preventDefault();
		$(this).next('.accordion-content').slideToggle();
		return false;
	});
	
	
  
  
  
	/*
	//
	//
	// SECTION HALF HIGHLIGHT SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.section-half-highlight-slider').each(function()
	{
		var $carousel = $(this).find('.owl-carousel');
		var $pagination_container = $(this).find('.carousel-pagination');
		var $navigation_container = $(this).find('.carousel-nav');
		
		$carousel.owlCarousel(
		{
			loop:true,
			items: 1,
			center:true,
			pagination:true,
			dotsContainer:$pagination_container,
			nav:true,
			navContainer:$navigation_container,
			navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
			lazyLoad:true
		});		
	});
	
	
	/*
	//
	//
	// SECTION HALF SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.section-half-slider').each(function()
	{
		var $carousel = $(this).find('.owl-carousel');
		var $dots_container = $(this).find('.carousel-pagination');
		var $nav_container = $(this).find('.carousel-nav');
		
		$carousel.owlCarousel(
		{
			loop:true,
			items: 1,
			pagination:true,
			center:true,
			nav:true,
			lazyLoad:true,
			dotsContainer:$dots_container,
			navContainer:$nav_container,
			navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"]
		});
	});
	
	
	
	/*
	//
	//
	// FRIDAY SLIDER
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#friday-slider .owl-carousel').owlCarousel(
	{
		loop:true,
		items: 1,
		pagination:false,
		center:true,
		nav:true,
		lazyLoad:true,
		navContainer:$('#friday-slider .carousel-nav'),
		navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"]
	});
	
	
	
	/*
	//
	//
	// PRODUCTS SLIDERS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.products-slider').each(function()
	{
		var $slider = $(this);
		var $nav_container = $(this).parents('.products-slider-wrap').find('.products-slider-nav');
		var max_items = 3;
		
		if ($slider.parents('.products-slider-wrap').attr('data-max-items'))
		{
			max_items = $slider.parents('.products-slider-wrap').attr('data-max-items');
		}
		
		initCarousel($slider, $nav_container, max_items);
	});
	
	/*
	//
	//
	// INIT CAROUSEL
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	function initCarousel($slider, $nav_container, max_items)
	{
		$slider.owlCarousel(
		{
			loop:false,
			items: 1,
			pagination:false,
			center:false,
			lazyLoad:true,
			nav:true,
			navContainer:$nav_container,
			navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
			
			responsive:
			{
	    	0:
	    	{
	        items:1.2,
	        center:true
	    	},
				450:
				{
	        items:2.1,
	        center:false
	    	},
				768:
				{
	        items:max_items,
	        center:false
	    	}
			}
		});	
	}
	
	
	
	/*
	//
	//
	// SQUARE SINGLE IMAGE PRODUCT CAROUSEL
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	var $nav_container = $('#product-images .carousel-nav');
	
	$('#product-images .owl-carousel').owlCarousel(
	{
		loop:true,
		items:1,
		nav:true,
		pagination:true,
		center:true,
		lazyLoad:true,
		dotsContainer:'#product-images-pagination',
		navContainer:$nav_container,
		navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
	});
	
	
	$('#product-images a.magnifik').magnifik();
	
	$('#product-images a.magnifik').on('magnifik:open', function(event)
	{
		$('body').append("<a id='custom-close-magnifik' class='m-close'>&times;</a>");
		//console.log('event has been fired');
	});
	
	$('#product-images a.magnifik').on('magnifik:close', function(event)
	{
		$('#custom-close-magnifik').remove();
		//console.log('close event has been fired');
	});
	
	$('body').on('click','#custom-close-magnifik',function(e)
	{
		$('.magnifik').magnifik('close');
	});
	
	
	
	

	

	/*
	//
	//
	// DESIGNER READ MORE LINK
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#designer-read-more-link').click(function(e)
	{
		e.preventDefault();
		
		$('#designer-truncated-content').hide();
		$('#designer-full-content').show();
		
		return false;
	});







	/*
	//
	//
	// PRODUCT VARIANTS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	if (typeof(PRODUCT_JSON) !== 'undefined')
	{
		/*
		//
		//
		// SIZE OPTION SELECTOR
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('.product-options-size a').click(function(e)
		{
			e.preventDefault();
						
			$(this).siblings().removeClass('selected');
			$(this).addClass('selected');
		
			selectVariant();
			updateOptionsAvailability();
			
			return false;
		});
		
		/*
		//
		//
		// OPTION SELECTOR DROPDOWN
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('.product-options select').on('change', function(e)
		{
			selectVariant();	
			updateOptionsAvailability();
		});
		
		/*
		//
		//
		// UPDATE OPTIONS AVAILABILITY
		// => CURRENTLY SUPPORT FOR MAX 2 OPTIONS
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		updateOptionsAvailability();
		
		function updateOptionsAvailability()
		{
			/*
			//
			//
			// SINGLE OPTION
			//
			//
			///////////////////////////////////////////////////////////////////////////// */
			if ($('.product-options').length == 1)
			{
				var option1 = $('.product-options')[0];
				
				if ($(option1).hasClass('product-options-size'))
				{
					var option_selections = $(option1).find('a');
				}
				else
				{
					var option_selections = $(option1).find('option');
				}
				
				$.each(option_selections, function(i,v)
				{
					var option_element = $(this);
					var option_value = $(this).attr('data-value');
					
					$.each(PRODUCT_JSON.variants, function(vi, variant)
					{
						if (variant.option1 == option_value)
						{
							if (!variant.available)
							{
								if (option_element.is('a'))
								{
									option_element.addClass('out-of-stock');
								}
								else
								{
									option_element.text($(option_element).attr('data-value') + ' - Out of Stock');
								}
							}
							else
							{
								if (option_element.is('a'))
								{
									option_element.removeClass('out-of-stock');
								}
								else
								{
									option_element.text($(option_element).attr('data-value'));
								}
							}
						}
					});
				});
			}
			/*
			//
			//
			// TWO OPTIONS
			//
			//
			///////////////////////////////////////////////////////////////////////////// */
			else if ($('.product-options').length == 2)
			{
				var option1 = $('.product-options')[0];
				
				if ($(option1).hasClass('product-options-size'))
				{
					var selected_option1 = $(option1).find('a.selected').attr('data-value');
				}
				else
				{
					var selected_option1 = $(option1).find('option:selected').attr('data-value');
				}
				
				var option2 = $('.product-options')[1];
				
				if ($(option2).hasClass('product-options-size'))
				{
					var option_selections = $(option2).find('a');
				}
				else
				{
					var option_selections = $(option2).find('option');
				}
				
				$.each(option_selections, function(i, option)
				{
					var option_element = $(this);
					var option_value = $(this).attr('data-value');
					
					$.each(PRODUCT_JSON.variants, function(i, variant)
					{
						if (variant.option1 == selected_option1 && variant.option2 == option_value)
						{
							if (!variant.available)
							{
								if (option_element.is('a'))
								{
									option_element.addClass('out-of-stock');
								}
								else
								{
									option_element.text($(option_element).attr('data-value') + ' - Out of Stock');
								}
							}
							else
							{
								if (option_element.is('a'))
								{
									option_element.removeClass('out-of-stock');
								}
								else
								{
									option_element.text($(option_element).attr('data-value'));
								}
							}
						}
					});	
				});

			}
			
		}
		
		/*
		//
		//
		// SELECT VARIANT
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		function selectVariant()
		{
			//
			// GET SELECTED OPTIONS
			//
			var options = [];
			
			$('.product-options').each(function(i,element)
			{
				var option_number = $(this).attr('data-option-number');
				var option_value = false;
					
				if ($(this).hasClass('product-options-size'))
				{
					option_value = $(this).find('.selected').attr('data-value');
				}
				else
				{
					option_value = $(this).find('select option:selected').attr('data-value');
				}
				
				options[option_number] = option_value;
			});
			
			//
			// FIND SELECTED VARIANT
			//
			var found_variant = false;
			var variants = PRODUCT_JSON.variants;
			
			$.each(variants, function(i,variant)
			{
				if (variant.option1 == options[1] && variant.option2 == options[2] && variant.option3 == options[3])	
				{
					found_variant = variant;
				}
			});
			
			if (found_variant)
			{
				$('#product-variant-selector').val(found_variant.id).change();
			}
		}
		
		

		/*
		//
		//
		// UPDATE SELECTED VARIANT
		//
		//
		///////////////////////////////////////////////////////////////////////////// */
		$('#product-variant-selector').on('change', function(e)
		{
			//
			// UPDATE PRODUCT PRICE
			//
			var found_variant = false;
			var variant_id = $(this).val();
			
			$.each(PRODUCT_JSON.variants, function(i,variant)
			{
				if (variant.id == variant_id)
				{
					found_variant = variant;
				}
			});
			
			$('#product-price').text(Shopify.formatMoney(found_variant.price));
			
			$('#product-stock-notice').hide();
			$('#product-stock-notice').text('');
			
			//
			// OUT OF STOCK
			//
			if ($(this).find('option:selected').hasClass('disabled'))
			{
				$('#product-stock-notice').text('Sold Out');
				$('#product-stock-notice').show();
					
				var out_of_stock_text = $('#btn-add-to-cart').attr('data-out-of-stock-text');
				$('#btn-add-to-cart').text(out_of_stock_text);
				$('#btn-add-to-cart').addClass('btn-out-of-stock').addClass('BIS_trigger');
			}
			//
			// IN STOCK
			//
			else
			{
				//
				// LOW STOCK
				//
				if (found_variant.inventory_management == 'shopify' && found_variant.inventory_policy != 'continue')
				{
					if (found_variant.inventory_quantity == 1)
					{
						$('#product-stock-notice').text('Last One!');
						$('#product-stock-notice').show();
					}
					else if (found_variant.inventory_quantity == 2)
					{
						$('#product-stock-notice').text('Only 2 Left!');
						$('#product-stock-notice').show();
					}
					else if (found_variant.inventory_quantity <= 5)
					{
						$('#product-stock-notice').text('Only a few left!');
						$('#product-stock-notice').show();
					}
				}
				
				var in_stock_text = $('#btn-add-to-cart').attr('data-in-stock-text');
				$('#btn-add-to-cart').text(in_stock_text);
				$('#btn-add-to-cart').removeClass('btn-out-of-stock').removeClass('BIS_trigger');
			}
			
			var variant_id = $(this).val();
			
			$('#btn-add-to-cart').attr('data-variant-id', variant_id);
			
		});
		
		//
		//
		// TRIGGER VARIANT SELECTOR
		//
		//
		$('#product-variant-selector').trigger('change');
		
	}

		
	/*
	//
	//
	// PRODUCT INFO COLLAPSIBLE
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.collapsible-header').click(function(e)
	{
		e.preventDefault();
		
		var $content = $(this).parents('.product-collapsible').find('.collapsible-content');
		
		if ($content.is(':visible'))
		{
			$content.slideUp();
		}
		else
		{
			$content.slideDown();	
		}
		
		return false;
	});
	
	

	
	/*
	//
	//
	// ADD TO CART
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#btn-add-to-cart').click(function(e)
	{
		e.preventDefault();
		
		var $btn = $(this);
		
		//
		// OUT OF STOCK
		//
		if ($btn.hasClass('btn-out-of-stock'))
		{
			return;
		}
		
		//
		// IN STOCK
		//
		$btn.attr('data-text', $(this).text());	
		$btn.html("<div class='btn-spinner'></div>").addClass('btn-spinning');
		
		var variant_id = $btn.attr('data-variant-id');
		
		CartJS.addItem(variant_id, 1, {},
		{
    	'success': function(data, textStatus, jqXHR)
    	{
        $btn.html($btn.attr('data-success-text')).removeClass('btn-spinning');
				$btn.html("<svg class='icon-check' width='13' viewBox='0 0 52 52' style='stroke:#000000;'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#icon-check'></use></svg> In Bag");
		
    	},
			'error': function(jqXHR, textStatus, errorThrown)
			{
				// IF OUT OF STOCK AFTER ALREADY ADDING TO CART.
				$('#product-stock-notice').text('This product is no longer available.');
				//$('<p>This product is no longer available.</p>').insertBefore($btn);
				
				//console.log(textStatus);
        //alert('Error: ' + errorThrown + '!');
    	}
		});
		
		return false;
	});
	
	
	/*
	//
	//
	// SOCIAL SHARE BUTTONS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('.social-share-links a').click(function(e)
	{
		if ($(this).attr('title') != 'Pinterest')
		{
			e.preventDefault();
			openSharePopup($(this).attr('href'));	
			return false;
		}
	});
	
	function openSharePopup(url)
	{
		var width = 560;
		var height = 440;
		var left = Number((screen.width/2)-(width/2));
		var top = Number((screen.height/2)-(height/2));
		
		var new_window = window.open(url, '_blank', 'height='+height+',width='+width+',top='+top+',left='+left+',scrollbars=yes,resizable=yes');
		if (window.focus) { new_window.focus(); }
		return false;
	}
		
		
	/*
	//
	//
	// CART UPDATED EVENT
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$(document).on('cart.requestComplete', function(event, cart)
	{
		$('.cart-total-items').text(cart.item_count);
		
		loadCarts();
	});
  
  /*
	//
	//
	// LOAD CARTS
	// => LOADS CART ITEMS INTO BOTH MINI CART (RIGHT SHELF) AND BIG CART (ON CART PAGE)
	//
	//
	///////////////////////////////////////////////////////////////////////////// */  
	loadCarts();
	
	function loadCarts()
	{
		//console.log(CartJS.cart);
		
		//
		//
		// RESET CART ELEMENTS
		//
		//
		$('.cart-loader').show();
		$('.cart-items').html('');
		$('.cart-totals').hide();
		$('.cart-empty-notice').hide();
		$('.btn-continue-to-checkout').hide();
		
		//
		//
		// EMPTY CART
		//
		//
		if (CartJS.cart.item_count == 0)
		{
			$('.cart-subtotal span').text(Shopify.formatMoney(0));
			$('.cart-loader').hide();
			$('.cart-empty-notice').show();
		}
		//
		//
		// FULL CART
		//
		//
		else
		{
			$.each(CartJS.cart.items, function(i,item)
			{
				var $item_html = $('#cart-item-html').clone().removeAttr('id').attr('data-item-line-number', (i+1));
				$item_html.attr('data-product-handle', item.handle);
				$item_html.attr('data-variant-id', item.id);
				
				$item_html.find('.cart-item-img img').attr('src', item.image);
				$item_html.find('.cart-item-img a').attr('href', item.url);
				
				$item_html.find('.cart-item-content h1').text(item.product_title);
				$item_html.find('.cart-item-content h2').text(item.variant_title);
				$item_html.find('.cart-item-content p').html(Shopify.formatMoney(item.price) + ' &times; ' + item.quantity + '<span>' + Shopify.formatMoney(item.line_price) + '</span>');
				
				$item_html.find('.cart-item-qty input').val(item.quantity).attr('data-initial-qty', item.quantity);
				
				if ($('#big-cart-items').length > 0)
				{
					$item_html.clone().appendTo('#big-cart-items');
				}
				
				$item_html.appendTo('#mini-cart-items');
			
			});
			
			$('.cart-item').not('#cart-item-html').show();
			$('.cart-subtotal span').text(Shopify.formatMoney(CartJS.cart.total_price));
			$('.cart-totals').show();
			$('.cart-loader').hide();
			$('.btn-continue-to-checkout').show();
		}
		
	}


	/*
	//
	//
	// TOGGLE UPDATE QUANTITY BUTTONS
	//
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('.cart-container').on('mouseup keyup', '.cart-item-qty input[type=number]', function(e)
	{
		$(this).parents('.cart-item').find('.cart-max-quantity-error').hide();
		
		var keycode = e.keyCode ? e.keyCode : e.which;
		if (keycode == '13')
		{
			$(this).parents('.cart-item').find('.btn-cart-update-qty').trigger('click');
		}
	  else
	  {
			if ($(this).val() == $(this).attr('data-initial-qty'))
			{
				$(this).parents('.cart-item').find('.btn-cart-update-qty').hide();
			}
			else
			{
				$(this).parents('.cart-item').find('.btn-cart-update-qty').show();	
			}
		}
	});
	
	/*
	//
	//
	// CLICK UPDATE QUANTITY BUTTONS
	//
	//
	//
	//////////////////////////////////////////////////////////////////////// */
	$('.cart-container').on('click', '.btn-cart-update-qty', function(e)
	{
		e.preventDefault();
		
		var $btn = $(this);
		
		var item_line_number = $(this).parents('.cart-item').attr('data-item-line-number');
		var product_handle = $(this).parents('.cart-item').attr('data-product-handle');
		var variant_id = $(this).parents('.cart-item').attr('data-variant-id');
		
		var quantity = $(this).parents('.cart-item').find('.cart-item-qty input[type=number]').val();
		var max_qty = 100;
		
		$.getJSON('/products/' + product_handle + '.js', function(product)
		{
			$.each(product.variants, function(i,v)
			{
				if (v.inventory_management == 'shopify')
				{
					if (v.id == variant_id)
					{
						max_qty = v.inventory_quantity;
					}
				}
			});
			
			if (quantity > max_qty)
			{
				$btn.parents('.cart-item').find('.btn-cart-update-qty').hide();
				$btn.parents('.cart-item').find('.cart-max-quantity-error').html('Only ' + max_qty + ' left');
				$btn.parents('.cart-item').find('.cart-max-quantity-error').show();
			}
			else
			{
				CartJS.updateItem(item_line_number, quantity, {},
				{
					'success': function(data, textStatus, jqXHR)
					{
						//console.log(data);
						//console.log(textStatus);
					},
					'error': function(jqXHR, textStatus, errorThrown)
					{
						//console.log(errorThrown);
					}
		    });		
			}
		});

  });
  
  
  
  
  
	
	/*
	//
	//
	// SELECT CONTAINERS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('select').on('focus',function()
	{
		$(this).parents('.select-container').addClass('focus');
	}).on('blur', function()
	{
		$(this).parents('.select-container').removeClass('focus');
	});

	/*
	//
	//
	// CUSTOMER ACCOUNTS
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	$('#btn-forgot-password').click(function(e)
	{
		e.preventDefault();
		
		$('#form-container-login').hide();
		$('#form-container-reset-password').show();
		
		return false;
	});
	
	$('#btn-cancel-reset-password').click(function(e)
	{
		e.preventDefault();
		
		$('#form-container-reset-password').hide();
		$('#form-container-login').show();
				
		return false;
	});

	if (window.location.hash == '#recover')
	{
		$('#form-container-login').hide();
		$('#form-container-reset-password').show();
	}
	
	/*
	//
	//
	// ADDRESSES
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	if ($('.form-add-address').length > 0)
	{
	  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new',
	  {
	    hideElement: 'address_province_container_new'
	  });
		
		$('.form-edit-address').each(function(i,element)
		{
			var address_id = $(this).attr('data-address-id');
				
			new Shopify.CountryProvinceSelector('address_country_' + address_id, 'address_province_' + address_id,
	    {
	      hideElement: 'address_province_container_' + address_id
	    });	
		});
	}
	
	$('.btn-delete-address').click(function(e)
	{
		e.preventDefault();
		if (confirm('Are you sure you want to delete this address?'))
		{
			Shopify.postLink('/account/addresses/' + $(this).attr('data-address-id'), { 'parameters': { '_method': 'delete' }});
		}
		return false;
	});
	
	
	
	
	/*
	//
	//
	// HANDLE NEWSLETTER MODAL
	//
	//
	///////////////////////////////////////////////////////////////////////////// */
	/*
	Cookies.set('name', 'value');
	Cookies.get('name');
	Cookies.get(); // => { name: 'value' }
	Cookies.remove('name');
	Cookies.set('name', { foo: 'bar' });
	Cookies.getJSON('name'); // => { foo: 'bar' }
	*/
	
	//Cookies.remove('newsletter-modal-shown');
	//Cookies.remove('pageviews-for-newsletter-modal');
	
	handleNewsletterModal();
	
	/*
	var newsletter_testing = getParameterByName('news');
	if (newsletter_testing == 1)
	{
		var inst = $('#newsletter-modal').remodal();
		inst.open();
	}
	*/
	
	function handleNewsletterModal()
	{
		var newsletter_modal_delay = 2000;
		var show_signup_on_page = 3 - 1;
		
		var newsletter_modal_shown = Cookies.get('newsletter-modal-shown');
		
		if (newsletter_modal_shown)
		{
			return;
		}
		
		var pageviews = parseInt(Cookies.get('pageviews-for-newsletter-modal'));
		
		if (!pageviews) pageviews = 0;
		
		if (pageviews >= show_signup_on_page)
		{
			setTimeout(function()
			{
				var inst = $('#newsletter-modal').remodal();
				inst.open();
			
				Cookies.set('newsletter-modal-shown', true);
			
			}, 2000);
		}
		
		pageviews++;
		Cookies.set('pageviews-for-newsletter-modal', pageviews);
	}
	
	
	
	/*
	//
	//
	// INSTAGRAM LIVE FEED
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
	if ($('.instagram-live-feed').length > 0)
	{
		loadInstagramLiveFeed();
	}
	
	function loadInstagramLiveFeed()
	{
		$.ajax(
		{
	    type: 'GET',
	    url: 'https://dev-shopify.vendorshippingrules.com/utilities/lei.php?callback=the_cb',
	    dataType: 'jsonp',
	
	  }).done(function(response)
	  {
		  //console.log(response);
			
			var $owl_carousel = $("<div class='owl-carousel'></div>");
			
			$.each(response.items, function(i, item)
			{
			  var src = item.images.standard_resolution.url;
			  var link = '/collections/instagram';//item.url;
			  var $img = $('<div class="instagram-feed-item"><a href="' + link + '"><img src="' + src + '" /></a></div>');
				$img.appendTo($owl_carousel);
			});
			
			$('.instagram-live-feed').prepend($owl_carousel);
			
			$('.instagram-live-feed .owl-carousel').owlCarousel(
			{
				loop:true,
				items:1,
				nav: true,
				navText:["<svg class='slider-arrow-left' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-left'></use></svg>","<svg class='slider-arrow-right' width='28' viewBox='0 0 129 129'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#arrow-right'></use></svg>"],
				pagination:false,
				responsive:
				{
		    	0:
		    	{
		        items:2,
		        center:true
		    	},
					450:
					{
		        items:3.2,
		        center:true
		    	},
					768:
					{
		        items:3.6,
		        center:true
		    	},
		    	1124:
		    	{
			    	items:4.6,
			    	center:true
		    	}
				}
			});
			  
	  }).fail(function(error)
	  {
		 	//console.log(error);
			$('.section-instagram').hide();
		});
	  
	  return;
	}
	
	
	/*
	//
	//
	// FORCE LOAD UNLOADED CAROUSEL IMAGES AFTER PAGE HAS LOADED
	//
	//
	//////////////////////////////////////////////////////////////////////////////////// */
	$(window).on('load', function()
	{
		$('.owl-lazy').each(function()
		{
			var src = $(this).attr('data-src');
			$(this).attr('src', src);
			$(this).removeClass('owl-lazy');
		});
	});
	
		
	
});



/*
//
//
// GET URL PARAM
//
//
//////////////////////////////////////////////////////////////////////////////////// */
function getParameterByName(name, url)
{
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
//
//
// GET URL PARAM; SPLIT CSV INTO ARRAY
//
//
//////////////////////////////////////////////////////////////////////////////////// */
function getParameterArray(name)
{
	var param = getParameterByName(name);
	
	if (!param || param.length < 1) return [];
	
	params = param.split(',');
	return params;
}